<template>
  <header class="all-100 align-left">
      <h1>
          <a class="logo push-left" href="https://estrelasemcasa.foxtv.pt/" target="_blank">FOX</a>
      </h1>
  </header>
</template>

<script>
export default {
  name: 'HeaderLogo',
}
</script>
